import Circular from "@/components/Circular";
import ErrorMessage from "@/components/ErrorMessage";
import { SearchResultSection } from "@/pages/SearchIndexPage/components/SearchResultSection";
import useSearchIndex from "@/pages/SearchIndexPage/hooks/useSearchIndex";
import useSearchIndexResults from "@/pages/SearchIndexPage/hooks/useSearchIndexResults";
import { FC } from "react";

type Props = {
  keyword: string;
};

const SearchResultContent: FC<Props> = ({ keyword }) => {
  const { response, mutate } = useSearchIndex(keyword, true);
  const { data, error, isLoading } = response;
  const { results, noResult } = useSearchIndexResults(data);

  if (error) return <ErrorMessage />;

  if (isLoading || !data) return <Circular />;

  if (noResult) return <p>該当するものが見つかりませんでした</p>;

  return (
    <div className="flex flex-col gap-80">
      {results
        .filter((result) => result.count > 0) // セクションは0件を表示しない
        .map((result) => (
          <SearchResultSection
            key={result.section_id}
            result={result}
            keyword={keyword}
            mutateItems={mutate}
          />
        ))}
    </div>
  );
};
export default SearchResultContent;
